import clsx from 'clsx'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Icon from '../../ui-kit/Icon/Icon'
import OfferOTCSettingsList, {
  OfferOTCSettingsListProps,
} from './OfferOTCSettingsList'
import { AnimatePresence } from 'framer-motion'
import Collapse from 'src/common/ui-kit/Animations/Collapse'

interface OfferOTCSettingsProps extends OfferOTCSettingsListProps {
  open?: boolean
  onToggle?: () => void
  className?: string
}

const OfferOTCSettings: React.FC<OfferOTCSettingsProps> = ({
  open,
  settings,
  offerWithNft,
  showOfferFillType = true,
  showTimelock = true,
  onToggle,
  onChangeSettings,
  className,
}) => {
  const { t } = useTranslation('common')
  const bottomRef = useRef<HTMLDivElement>(null)

  const scrollIntoView = () =>
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })

  return (
    <div className={clsx('w-full', className)}>
      <div>
        <div
          className='paper p-4 paper cursor-pointer hover:bg-paper-accent group'
          onClick={() => onToggle?.()}
        >
          <div className='flex justify-between items-center'>
            <div className='typo-label2 group-hover:text-primary'>
              {t('offerOTCSettings.title', 'OTC settings')}
            </div>
            <Icon
              className={clsx('group-hover:text-primary')}
              name='settings'
              strokeWidth='0.1px'
            />
          </div>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <Collapse
            onAnimationComplete={scrollIntoView}
            className='col-span-12'
          >
            <OfferOTCSettingsList
              className='mt-2 paper p-4'
              settings={settings}
              offerWithNft={offerWithNft}
              showOfferFillType={showOfferFillType}
              showTimelock={showTimelock}
              onChangeSettings={onChangeSettings}
            />
            <div ref={bottomRef} />
          </Collapse>
        )}
      </AnimatePresence>
    </div>
  )
}

export default OfferOTCSettings
